module.exports = __webpack_public_path__ + "static/media/record-3.acf978e6.png";